import React from 'react';

const MovieItem = ({ img, title, char, overview }) => {
  return (
    <div className="filmography-item-container">
      <div className="filmography-item-container-wrapper">
        <div className="filmography-item-container-wrapper-title">
          <img
            src={img}
            alt={title}
            className="filmography-item-container-wrapper-title__img"
          />
          <div className="filmography-item-container-wrapper-title-main">
            <h3 className="filmography-item-container-wrapper-title-main__name">
              {title}
            </h3>
            <p className="filmography-item-container-wrapper-title-main__role">
              {char}
            </p>
          </div>
        </div>
        <div className="filmography-item-container-description">
          <p className="filmography-item-container-description-text">
            {overview}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MovieItem;
